import { DetailAction } from '../DetailAction';
import { DetailTranslationKeys, ErrorTranslationKeys } from '../../../../api/models/TranslationKeys';
import { SubscriptionTypes } from './SubscriptionSettings.types';
import { SelectOptionDialog } from '../../../../components/option/SelectOptionDialog';
import { Backend } from '../../../../api/Backend';
import { Recording } from '../../../../api/user/RecordingApi.types';
import { IProgramV5 } from '../../../../api/models/AndromeTV.types';
import { OptionCallback, OptionData } from '../../../../components/option/OptionData';
import { Lightning } from '@lightningjs/sdk';

export class EpgCancelRecordingAction extends DetailAction {
  private recording: Recording;
  private program: IProgramV5;
  private isParentRecordingPage: boolean;
  constructor(backend: Backend, recording: Recording, program: IProgramV5, isParentRecordingPage = false) {
    super(backend);
    this.recording = recording;
    this.program = program;
    this.isParentRecordingPage = isParentRecordingPage;
  }

  override doAction(modalOwner: Lightning.Component | undefined = undefined) {
    const options = this.getOptions();
    this.openCancelDialog(options, (selection: OptionData) => {
      const type = selection.value as SubscriptionTypes;
      this._backend.cachedRecordingsApi
        .cancelSubscription(this._backend, type, this.recording)
        .then(() => {
          this.owner?.fireAncestors('$closeDialog');
          this.owner?.fireAncestors('$reloadDetailContent', true);
          if (this.isParentRecordingPage) {
            // signal to remove item
            if (modalOwner) modalOwner.fireAncestors('$removeEpgElement', modalOwner, type);
          }
        })
        .catch(() => {
          this.owner?.fireAncestors(
            '$showMessage',
            this._backend.translations.forKey(ErrorTranslationKeys.error_recording_delete_failed)
          );
        });
    });
  }

  openCancelDialog(options: OptionData[], callback: OptionCallback) {
    const title = `${this._backend.translations.forKey(DetailTranslationKeys.detail_recording_cancel_popup_title)} ${
      this.program.text.title
    }`;
    this.owner?.fireAncestors('$openDialog', {
      type: SelectOptionDialog,
      params: {
        backend: this._backend,
        title: title,
        options: options,
        onSuccess: callback,
        onCancelled: () => {
          this.owner?.fireAncestors('$closeDialog');
        },
      },
    });
  }

  getOptions() {
    const result: OptionData[] = [
      {
        text: this._backend.translations.forKey(DetailTranslationKeys.detail_recording_cancel_program),
        value: SubscriptionTypes.PROGRAM,
        options: [],
      },
    ];
    if (this.recording.seriesSubscription || this.recording.seasonSubscription) {
      result.push({
        text: this._backend.translations.forKey(DetailTranslationKeys.detail_recording_cancel_season),
        value: SubscriptionTypes.SEASON,
        options: [],
      });
    }

    if (this.recording.seriesSubscription) {
      result.push({
        text: this._backend.translations.forKey(DetailTranslationKeys.detail_recording_cancel_series),
        value: SubscriptionTypes.SERIES,
        options: [],
      });
    }
    return result;
  }
}
